(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kaplan-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaplan-announcement')) {
    customElements.define('kaplan-announcement', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        this.querySelector('[data-announcement-pause]').addEventListener('click', event => {
          const paused = this.toggleAttribute('data-paused');
          const button = event.currentTarget;
          button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          button.setAttribute('aria-pressed', String(paused));
          button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaplan-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaplan-hero-slider')) {
    customElements.define('kaplan-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slider-to]'));
        this.copy = this.querySelector('[data-slider-copy]');
        this.index = 0;
        this.delay = Math.max(4000, Number(this.dataset.delay) || 6000);
        this.style.setProperty('--slider-delay', this.delay + 'ms');
        this.userPaused = this.dataset.autoplay === 'false';
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        if (this.slides.length < 2) return;
        this.querySelector('[data-slider-controls]').hidden = false;
        this.addEventListener('click', event => {
          const control = event.target.closest('[data-slider-action], [data-slider-to]');
          if (!control || !this.contains(control)) return;
          const action = control.dataset.sliderAction;
          if (action === 'pause') {
            this.userPaused = !this.userPaused;
            this.sync();
          } else if (action === 'previous') this.go(this.index - 1, true);
          else if (action === 'next') this.go(this.index + 1, true);
          else if (control.dataset.sliderTo !== undefined) this.go(Number(control.dataset.sliderTo), true);
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.sync();
        }, { signal });
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.sync();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focused = true;
          this.sync();
        }, { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          this.focused = this.contains(document.activeElement);
          this.sync();
        }), { signal });
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[data-slider-controls]')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, { signal });
        this.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'touch') return;
          this.touchStart = { x: event.clientX, y: event.clientY };
        }, { signal });
        this.addEventListener('pointerup', event => {
          if (!this.touchStart || event.pointerType !== 'touch') return;
          const dx = event.clientX - this.touchStart.x;
          const dy = event.clientY - this.touchStart.y;
          this.touchStart = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) this.go(this.index + (dx < 0 ? 1 : -1), true);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => this.sync(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
          if (selected < 0) return;
          this.userPaused = true;
          this.go(selected, true);
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].intersectionRatio > 0.15;
          this.sync();
        }, { threshold: [0, 0.15] });
        this.observer.observe(this);
        this.sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.copyTimer);
        this.initialized = false;
      }
      sync() {
        clearTimeout(this.timer);
        const paused = this.userPaused || this.hovered || this.focused || this.motion.matches || document.hidden || !this.inView;
        this.toggleAttribute('data-paused', paused);
        const button = this.querySelector('[data-slider-action="pause"]');
        if (button) {
          button.hidden = this.motion.matches;
          button.setAttribute('aria-label', this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
          button.setAttribute('aria-pressed', String(this.userPaused));
          button.querySelector('[data-slider-pause-icon]').textContent = this.userPaused ? '▶' : 'Ⅱ';
        }
        if (!paused && this.slides.length > 1) this.timer = setTimeout(() => this.go(this.index + 1, false), this.delay);
      }
      go(index, manual) {
        const next = (index + this.slides.length) % this.slides.length;
        if (next === this.index) return;
        this.index = next;
        this.slides.forEach((slide, i) => {
          const active = i === next;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === next);
          dot.setAttribute('aria-current', String(i === next));
        });
        const data = this.slides[next].dataset;
        clearTimeout(this.copyTimer);
        const update = () => {
          const fields = ['title', 'emphasis', 'eyebrow', 'description', 'button', 'note'];
          fields.forEach(field => {
            const node = this.querySelector('[data-slider-' + field + ']');
            if (node) node.textContent = data[field] || '';
          });
          this.querySelector('[data-slider-link]').href = data.url;
          this.querySelector('[data-slider-counter]').textContent = String(next + 1).padStart(2, '0') + ' / ' + String(this.slides.length).padStart(2, '0');
          this.copy.classList.remove('is-changing');
          if (manual) this.querySelector('[data-slider-status]').textContent = (next + 1) + '. slayt: ' + data.title + ' ' + data.emphasis;
        };
        if (this.motion.matches) update();
        else {
          this.copy.classList.add('is-changing');
          this.copyTimer = setTimeout(update, 220);
        }
        this.sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
